module.exports = __webpack_public_path__ + "img/hr.3c3cb4e0.svg";